import { drawRect } from "./drawRect";

const drawStartRole = (container, data, onDrag) => {
  const bindingData = data
    ? [data]
    : container.datum()
      ? [container.datum()]
      : [];
  drawRect(container, data, onDrag);

  const diag1 = container.selectAll("line.diag1").data(bindingData);
  diag1
    .enter()
    .append("line")
    .classed("diag1", true)
    .merge(diag1)
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", (d) => d.size.width)
    .attr("y2", (d) => d.size.height);

  diag1.exit().remove();

  const diag2 = container.selectAll("line.diag2").data(bindingData);
  diag2
    .enter()
    .append("line")
    .classed("diag2", true)
    .merge(diag2)
    .attr("x1", (d) => d.size.width)
    .attr("y1", 0)
    .attr("x2", 0)
    .attr("y2", (d) => d.size.height);

  diag2.exit().remove();
};

export { drawStartRole };
